export const OPEN_BLOCKED_SEATS_MODAL = 'OPEN_BLOCKED_SEATS_MODAL';
export const CLOSE_BLOCKED_SEATS_MODAL = 'CLOSE_BLOCKED_SEATS_MODAL';
export const ADD_BLOCKED_SEAT = 'ÁDD_BLOCKED_SEAT';
export const REMOVE_BLOCKED_SEAT = 'REMOVE_BLOCKED_SEAT';
export const SET_BLOCKED_SEATS = 'SET_BLOCKED_SEATS';
